import React from 'react';
import * as ObjectConst from '../constants/Property';

export const getImgURLForConvenience = name => {
    return '/static/imgs/objects/convenience/' + name + '.svg';
};

export const getCurrencyMarkByValue = value => {
    if (value !== undefined) {
        return ObjectConst.CURRENCY[value].mark;
    } else {
        return '';
    }
};

export const getTranslateByCode = (translates, code) => {
    let result = translates.find(elem => elem.languageCode === code);
    return result != undefined ? result : translates[0];
};

export const getDisplayName = (code, object) => {
    const translates = object.meta.translates;
    const displayName = object.description.displayName;
    let response = '';

    if (translates !== undefined && translates !== null && code !== undefined) {
        const translate = getTranslateByCode(translates, code);
        if (translate !== undefined) {
            response = translate.displayName;
        }
    } else if (displayName !== undefined && displayName !== null) {
        response = displayName;
    }
    return response;
};

export const getPriceRentBlock = (property, i18n, requiredType) => {
    const objectType = property.props.type;
    const objectTypeTerm = property.props.typeTerm;
    const currency = property.price.currencyMark;
    let priceRentBlock = [];

    if (requiredType !== undefined) {
        if (requiredType === ObjectConst.TYPE.SELL) {
            priceRentBlock.push(
                <span key={`sell_${property.id}`} className="price">
                    {property.price.priceSell.toLocaleString()} {currency}
                </span>
            );
        } else {
            if (objectTypeTerm === ObjectConst.TYPE_TERM.ALL || objectTypeTerm === ObjectConst.TYPE_TERM.HOLIDAY) {
                priceRentBlock.push(
                    <span key={property.id} className="price">
                        {i18n['objectPreview.from']} {property.price.priceRentBase.toLocaleString()} {currency} / {i18n['objectPreview.night']}
                    </span>
                );
            } else {
                priceRentBlock.push(
                    <span key={property.id} className="price">
                        {property.price.priceRentLong.toLocaleString()} {currency} / {i18n['objectPreview.month']}
                    </span>
                );
            }
        }
    } else {
        if (objectType === ObjectConst.TYPE.ALL || objectType === ObjectConst.TYPE.SELL) {
            priceRentBlock.push(
                <span key={`sell_${property.id}`} className="price">
                    {property.price.priceSell.toLocaleString()} {currency}
                </span>
            );
        }

        if (objectType === ObjectConst.TYPE.ALL || objectType === ObjectConst.TYPE.RENT) {
            if (objectTypeTerm === ObjectConst.TYPE_TERM.ALL || objectTypeTerm === ObjectConst.TYPE_TERM.HOLIDAY) {
                priceRentBlock.push(
                    <span key={property.id} className="price">
                        {i18n['objectPreview.from']} {property.price.priceRentBase.toLocaleString()} {currency} / {i18n['objectPreview.night']}
                    </span>
                );
            } else {
                priceRentBlock.push(
                    <span key={property.id} className="price">
                        {property.price.priceRentLong.toLocaleString()} {currency} / {i18n['objectPreview.month']}
                    </span>
                );
            }
        }
    }
    return priceRentBlock;
};



// WEBPACK FOOTER //
// ./src/utils/Property.js